// extracted by mini-css-extract-plugin
module.exports = {"carousel":"HeroQuiz_carousel__KX7uR","pen4889Variant1":"HeroQuiz_pen4889Variant1__7MwEd"};